function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PlotCheckboxList from 'js/containers/legacy/PlotCheckboxList';
import Modal from '.';

var SelectedSourcesModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectedSourcesModal, _React$Component);

  function SelectedSourcesModal() {
    _classCallCheck(this, SelectedSourcesModal);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectedSourcesModal).apply(this, arguments));
  }

  _createClass(SelectedSourcesModal, [{
    key: "render",
    value: function render() {
      var ModalTitle = React.createElement("div", {
        className: "cndc-checkbox-list-wrapper"
      }, React.createElement(PlotCheckboxList, {
        plotMetadata: this.props.content.plotMetadata,
        plotSectionId: this.props.content.plotSectionId,
        plotDataTypes: this.props.content.plotMetadataAdditional.grouped_types
      }));
      return React.createElement(Modal, _extends({}, this.props, {
        closeable: true,
        title: ModalTitle
      }), React.createElement("div", {
        className: "modal-view-body"
      }, React.createElement("div", {
        className: "modal-view-scroll-area",
        ref: "modalViewScrollArea"
      }, this.props.content.selectCheckboxesText), React.createElement("div", {
        className: "modal-view-footer"
      }, React.createElement("div", null, React.createElement("div", {
        className: "btn-default-wrapper"
      }, React.createElement("button", {
        className: "btn",
        onClick: this.props.content.plotClearCheckboxes
      }, React.createElement("span", {
        className: "glyphicon glyphicon-remove-sign"
      }), " ".concat(this.props.content.checkboxClearButtonText))), React.createElement("div", {
        className: "btn-primary-wrapper"
      }, React.createElement("button", {
        className: "btn btn-primary",
        onClick: this.props.modalClose
      }, React.createElement("span", {
        className: "glyphicon glyphicon-ok"
      }), " ".concat(this.props.content.doneSelectingCheckboxesText)))))));
    }
  }]);

  return SelectedSourcesModal;
}(React.Component);

export { SelectedSourcesModal as default };